import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AddIcon from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";
import GetApp from "@material-ui/icons/GetApp";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import { redirectToLogout, numericSortFunc } from "common/SharedFn";
import { getAllBanners, addBanner, updateBanner, deleteBanner } from "../../network/ApiAxios";
import { Delete, Edit } from "@material-ui/icons";
import "react-datepicker/dist/react-datepicker.css";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage: 50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const BannersTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [countries, setCountries] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [addModal, setAddModal] = useState(false);
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [color, setColor] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [titleAr, setTitleAr] = useState("");
  const [subtitleAr, setSubtitleAr] = useState("");
  const [buttonTextAr, setButtonTextAr] = useState("");
  const [buttonColor, setButtonColor] = useState("");
  const [buttonIcon, setButtonIcon] = useState("");
  const [sideImage, setSideImage] = useState("");
  const [action, setAction] = useState(0);
  const [coupon, setCoupon] = useState("");
  const [noOrdersOnly, setNoOrdersOnly] = useState(0);
  const [isProOnly, setIsProOnly] = useState(0);
  const [orderNo, setOrderNo] = useState(1);
  const [id, setId] = useState();
  const [executeUpdate, setExecuteUpdate] = useState(false);
  const [executeDelete, setExecuteDelete] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  const [sideImageFile, setSideImageFile] = React.useState(null);
  const [buttonIconFile, setButtonIconFile] = React.useState(null);
  let history = useHistory();

  let sideImageFileInputRef = React.createRef();
  let buttonIconFileInputRef = React.createRef();

  const handleSideImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let newFile = e.target.files[0];
    reader.onloadend = () => {
      setSideImageFile(newFile);
    };
    if (newFile) {
      reader.readAsDataURL(newFile);
    }
  };

  const handleButtonIconChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let newFile = e.target.files[0];
    reader.onloadend = () => {
      setButtonIconFile(newFile);
    };
    if (newFile) {
      reader.readAsDataURL(newFile);
    }
  };

  const warningAlert = (title, message, action) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const setCurrentRecord = (info) => {
    const { id,
      title,
      subtitle,
      color,
      buttonText,
      titleAr,
      subtitleAr,
      buttonTextAr,
      buttonColor,
      buttonIcon,
      sideImage,
      action,
      coupon,
      noOrdersOnly,
      isProOnly,
      orderNo } = info;
    setTitle(title);
    setSubtitle(subtitle);
    setColor(color);
    setButtonText(buttonText);
    setTitleAr(titleAr);
    setSubtitleAr(subtitleAr);
    setButtonTextAr(buttonTextAr);
    setButtonColor(buttonColor);
    setButtonIcon(buttonIcon);
    setSideImage(sideImage);
    setAction(action);
    setCoupon(coupon);
    setNoOrdersOnly(noOrdersOnly);
    setIsProOnly(isProOnly);
    setOrderNo(orderNo);
    setId(id);
  };

  const clearCurrentRecord = () => {
    setTitle("");
    setSubtitle("");
    setColor("");
    setButtonText("");
    setTitleAr("");
    setSubtitleAr("");
    setButtonTextAr("");
    setButtonColor("");
    setButtonIcon("");
    setSideImage("");
    setAction("");
    setCoupon("");
    setNoOrdersOnly("");
    setIsProOnly(0);
    setOrderNo("");
    setSideImageFile(null);
    setButtonIconFile(null)
    setId();
    document.getElementById("sideImageFile").value = "";
    document.getElementById("buttonIconFile").value = "";
  };

  const fetchBanners = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try {
      const response = await getAllBanners();
      const { data } = response;
      if (data.result.isSuccess) {

        setData(data.data.map((prop) => makeTableRow(prop)));
        //setError("");
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    }
    catch (ex) {
      showErrorNotification("Failed to fetch banners");
    }
    setIsLoading(false);
  };



  const addBannerAction = async () => {
    setIsLoading(true);
    try {
      const response = await addBanner(title,
        subtitle,
        color,
        buttonText,
        titleAr,
        subtitleAr,
        buttonTextAr,
        buttonColor,
        buttonIcon,
        sideImage,
        action,
        coupon,
        noOrdersOnly,
        isProOnly,
        orderNo,
        sideImageFile,
        buttonIconFile);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Banner Added Successfully");
        setAddModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    }
    catch (ex) {
      showErrorNotification("Failed to add banner");
      setIsLoading(false);
    }
  };


  const updateBannerAction = async () => {
    setExecuteUpdate(false);
    setIsLoading(true);
    try {
      const response = await updateBanner(id, title,
        subtitle,
        color,
        buttonText,
        titleAr,
        subtitleAr,
        buttonTextAr,
        buttonColor,
        buttonIcon,
        sideImage,
        action,
        coupon,
        noOrdersOnly,
        isProOnly,
        orderNo,
        sideImageFile,
        buttonIconFile);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Banner Updated Successfully");
        setAddModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    }
    catch (ex) {
      showErrorNotification("Failed to update banner");
      setIsLoading(false);
    }
  };


  const deleteParam = async () => {
    setExecuteDelete(false);
    setIsLoading(true);
    try {
      const response = await deleteBanner(id);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Banner Deleted Successfully");
        setAddModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    }
    catch (ex) {
      showErrorNotification("Failed to delete banner");
      setIsLoading(false);
    }
  };

  useAsyncEffect(async () => {
    if (executeUpdate) {
      updateBannerAction();
    }
    else if (executeDelete) {
      deleteParam();
    }
    else {
      fetchBanners();
    }
  }, [executeUpdate, executeDelete, forceRefresh]);

  const makeTableRow = (info) => {
    if (info.noOrdersOnly == 0) {
      info.noOrdersOnlyText = "No";
    }
    else {
      info.noOrdersOnlyText = "Yes";
    }

    switch (info.isProOnly) {
      case -2:
        info.isProOnlyText = "Never Had Pro";
        break;
      case -1:
        info.isProOnlyText = "Not Pro";
        break;
      case 0:
        info.isProOnlyText = "All Users";
        break;
      case 1:
        info.isProOnlyText = "Pro Only";
        break;
    }

    switch (info.action) {
      case 0:
        info.actionText = "New Order";
        break;
      case 1:
        info.actionText = "Re Order";
        break;
      case 2:
        info.actionText = "Wallet";
        break;
      case 3:
        info.actionText = "Doobi Pro";
        break;
      case 4:
        info.actionText = "Refer";
        break;
    }
    return {
      ...info,
      sideImageDisp: (
        <img src={info.sideImage} width="50px" />
      ),
      buttonIconDisp: (
        <img src={info.buttonIcon} width="20px" />
      ),
      actions: (
        <div className="actions-right">
          <Tooltip title="Edit">
            <Button size="small"
              classes={{
                root: classes.buttonContainedWarning,
              }}
              variant="contained"
              style={{ marginLeft: "5px" }}
              onClick={() => {
                clearCurrentRecord();
                setCurrentRecord(info);
                setAddModal(true);
              }}>
              <Box component={Edit} />
            </Button>
          </Tooltip>

          <div style={{ display: "inline-block" }}>
            <Tooltip title="Delete">
              <Button
                size="small"
                classes={{
                  root: classes.buttonContainedError,
                }}
                variant="contained"
                style={{ marginLeft: "5px" }}
                onClick={() => {
                  warningAlert("Delete Banner", "Are you sure you would like to delete the banner with id " + info.id + "?", async () => {
                    setCurrentRecord(info);
                    setAlert(null);
                    setExecuteDelete(true);
                  })
                }}
              >
                <Box component={Delete} />
              </Button>
            </Tooltip>
          </div>
        </div>
      ),
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >

        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>

              <div style={{ width: "100%" }}>
                <ToolkitProvider
                  data={data}
                  keyField="id"
                  columns={[
                    {
                      dataField: "id",
                      text: "ID",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "title",
                      text: "Title",
                      sort: false,
                      csvExport: false,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "titleAr",
                      text: "Title Ar",
                      sort: false,
                      csvExport: false,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "subtitle",
                      text: "Subtitle",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "subtitleAr",
                      text: "Subtitle Ar",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "color",
                      text: "Color",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "buttonText",
                      text: "Button Text",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "buttonTextAr",
                      text: "Button Text Ar",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "buttonColor",
                      text: "Button Color",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "actionText",
                      text: "Action",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "noOrdersOnlyText",
                      text: "Users With No Orders Only",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "isProOnlyText",
                      text: "Pro Status",
                      sort: true,
                      style: { 'whiteSpace': 'normal' }
                    },

                    {
                      dataField: "orderNo",
                      text: "Order Number (Sequence)",
                      sort: true,
                      sortFunc: numericSortFunc,
                      style: { 'whiteSpace': 'normal' }
                    },
                    {
                      dataField: "actions",
                      classes: "actions-col",
                      headerClasses: "actions-col",
                      text: "Actions",
                      csvExport: false,
                    },
                  ]}
                  search
                  exportCSV
                >
                  {(props) => (
                                      <>
                  <CardHeader
                    style={{ paddingTop: "0.875rem", paddingBottom: "0.875rem" }}
                    title={
                      <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                        <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Banners</Box>
                    </Box>
                        </>
                        <Tooltip title="Add new banner">
                          <IconButton
                            size="small"
                            onClick={() => {
                                clearCurrentRecord();
                                setAddModal(true);
                              }}
                            style={{
                              width: 32, height: 32,
                              backgroundColor: "#fff",
                              border: "1px solid #5e72e4",
                              color: "#5e72e4",
                            }}
                          >
                            <AddIcon style={{ width: 18, height: 18 }} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    }
                    action={
                      <Box
                        display="flex" alignItems="center" flexWrap="wrap"
                        justifyContent="flex-end"
                        style={{ gap: 8, marginTop: 8, marginRight: 8 }}
                      >
                        <div
                          id="datatable-basic_filter"
                          style={{ display: "flex", alignItems: "center", height: 40 }}
                        >
                          <SearchBar
                            className="form-control-sm"
                            placeholder="Search..."
                            style={{ height: 40, margin: 0, boxSizing: "border-box" }}
                            {...props.searchProps}
                          />
                        </div>
                          {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                          {/* </Tooltip> */}
                        <Tooltip title="Download CSV">
                          <span style={{ display: "flex" }}>
                            <ExportCSVButton
                              className="MuiButtonBase-root"
                              style={{
                                width: 40, height: 40, padding: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                border: "1px solid #172b4d", borderRadius: 8,
                                color: "#fff", backgroundColor: "#172b4d", cursor: "pointer",
                              }}
                              {...props.csvProps}
                            >
                              <GetApp style={{ width: 18, height: 18 }} />
                            </ExportCSVButton>
                          </span>
                        </Tooltip>
                      </Box>
                    }
                  />
                  <div className="table-responsive">
                                            <BootstrapTable
                        ref={componentRef}
                        {...props.baseProps}
                        bootstrap4={true}
                        pagination={pagination}
                        bordered={true}
                        striped={true}
                        //filter={ filterFactory() }
                        noDataIndication={() =>
                          isLoading ? (
                            <Box
                              component={Grid}
                              container
                              justifyContent="center"
                              className="justify-content-center"
                            >
                              <div
                                className="text-center"
                                style={{ width: "20%" }}
                              >
                                <LoadingAnimation />{" "}
                              </div>
                            </Box>
                          ) : (
                            <h4>No Records</h4>
                          )
                        }
                        id="main-table"
                      />

                    </div>
                    </>
                  )}
                </ToolkitProvider>
              </div>
            </Card>
          </Grid>
        </Grid>
        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={addModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setAddModal(false)}
        >
          <DialogTitle
            disableTypography
            className={classes.modalHeader}
          >
            <h4 className={classes.modalTitle}>
              {id == null || id === "" ? "Add" : "Edit"} Banner
            </h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <form>
              <FormGroup>
                <FormLabel>Title</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="Title"
                  value={title ?? ""}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Title Arabic</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="Title Arabic"
                  value={titleAr ?? ""}
                  onChange={(e) => setTitleAr(e.target.value)}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Subtitle</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="Subtitle"
                  value={subtitle ?? ""}
                  onChange={(e) => setSubtitle(e.target.value)}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Subtitle Arabic</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="Subtitle Arabic"
                  value={subtitleAr ?? ""}
                  onChange={(e) => setSubtitleAr(e.target.value)}
                />
              </FormGroup>


              <FormGroup>
                <FormLabel>Color</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="#ffffff"
                  value={color ?? ""}
                  onChange={(e) => setColor(e.target.value)}
                />
              </FormGroup>


              <FormGroup>
                <FormLabel>Button Text</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="Button Text"
                  value={buttonText ?? ""}
                  onChange={(e) => setButtonText(e.target.value)}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Button Text Arabic</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="Button Text Arabic"
                  value={buttonTextAr ?? ""}
                  onChange={(e) => setButtonTextAr(e.target.value)}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Button Color</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="#ffffff"
                  value={buttonColor ?? ""}
                  onChange={(e) => setButtonColor(e.target.value)}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Coupon (If Applicable)</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="Valid Coupon Code (If Applicable)"
                  value={coupon ?? ""}
                  onChange={(e) => setCoupon(e.target.value)}
                />
              </FormGroup>


              <FormGroup>
                <FormLabel>Order Number (Sequence of Banner)</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="number"
                  placeholder="Sequence of Banner"
                  value={orderNo ?? ""}
                  onChange={(e) => setOrderNo(e.target.value)}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Show For Users With No Orders Only</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select value={noOrdersOnly} onChange={(e) => setNoOrdersOnly(e.target.value)} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={0}>No</MenuItem>
                    <MenuItem value={1}>Yes</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>

              <FormGroup>
                <FormLabel>Action</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select value={action} onChange={(e) => setAction(e.target.value)} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={0}>New Order</MenuItem>
                    <MenuItem value={1}>Re Order</MenuItem>
                    <MenuItem value={2}>Wallet</MenuItem>
                    <MenuItem value={3}>Doobi Pro</MenuItem>
                    <MenuItem value={4}>Refer</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>

              <FormGroup>
                <FormLabel>Pro Status</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select value={isProOnly} onChange={(e) => setIsProOnly(e.target.value)} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={0}>All Users</MenuItem>
                    <MenuItem value={1}>Pro Only</MenuItem>
                    <MenuItem value={-1}>Not Pro</MenuItem>
                    <MenuItem value={-2}>Never Had Pro</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>

              <FormGroup>
                <FormLabel>Side Image</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <div className="fileinput">
                    <div className={"thumbnail"}>
                      <img src={sideImage} width="100px" />
                    </div>
                    <input
                      type="file"
                      id="sideImageFile"
                      onChange={handleSideImageChange}
                      ref={sideImageFileInputRef}
                    />
                  </div>
                </FormControl>
              </FormGroup>



              <FormGroup>
                <FormLabel>Button Icon</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <div className="fileinput">
                    <div className={"thumbnail"}>
                      <img src={buttonIcon} width="50px" />
                    </div>
                    <input
                      type="file"
                      id="buttonIconFile"
                      onChange={handleButtonIconChange}
                      ref={buttonIconFileInputRef}
                    />
                  </div>
                </FormControl>
              </FormGroup>
            </form>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setAddModal(false)}
            >
              Cancel
            </Button>
            <Button
              onClick={() =>
                id == null || id === "" ? addBannerAction() : updateBannerAction()
              }

              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              {id == null || id === "" ? "Add" : "Update"}
            </Button>

          </DialogActions>
        </Dialog>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default BannersTable;
